import React from 'react'
import styled from 'styled-components'
import P from '../../commons/P'
import arrow from '../../../img/right_arrow_broken.png'
import H2 from '../../commons/H2'
import H1 from '../../commons/H1'
import {useNavigate} from "react-router-dom";
import Bold from "../../commons/Bold";


const Pluses = () => {
    const navigate = useNavigate()

    return (
    <Container>
      <StyledH1>Vuoi saperne di più?</StyledH1>
        <StyledP>Scopri come funziona PrestitoPuoi e accedi al servizio di Banca Sistema dedicato alla scelta del prestito personale.</StyledP>
      <StagesContainer>
        <Stage>
          <StyledH2>STEP 1</StyledH2>
          <StyledH2>Racconti la tua esigenza</StyledH2>
          <StyledP>Inserisci la tua richiesta e fornisci le informazioni necessarie</StyledP>
        </Stage>
        <Img src={arrow} alt={'Freccia verso destra'}/>
        <Stage>
          <StyledH2>STEP 2</StyledH2>
          <StyledH2>I nostri consulenti ti guideranno nella valutazione</StyledH2>
          <StyledP>Attraverso il servizio PrestitoPuoi, un consulente analizzerà la tua richiesta, contattandoti per ulteriori dettagli</StyledP>
        </Stage>
        <Img src={arrow} alt={'Freccia verso destra'}/>
        <Stage>
          <StyledH2>STEP 3</StyledH2>
          <StyledH2>Ricevi una proposta di finanziamento</StyledH2>
          <StyledP>Ottieni un preventivo personalizzato, costruito sulle tue esigenze. </StyledP>
        </Stage>
      </StagesContainer>
      <FooterP>
          DISCLAIMER** I finanziamenti proposti nell’ambito del servizio PrestitoPuoi sono <Bold>erogati da istituti e intermediari finanziari partner.</Bold><br/>
          Banca Sistema <Bold>non eroga direttamente il finanziamento,</Bold> ma opera come intermediario nell’ambito del servizio PrestitoPuoi.
      </FooterP>
      <LinkContainer>
        <LandingLink onClick={() => navigate('/landing-prestitopuoi')}>
           RICHIEDI QUI UNA PROPOSTA PERSONALIZZATA
        </LandingLink>
      </LinkContainer>
    </Container>
  )
}

// region Style
const Container = styled.div`
  max-width: 1125px;
  margin: 6rem auto 6rem auto;
  padding: 0 15px;
`
const StyledH1 = styled(H1)`
    font-size: 3rem;
    text-align: left;
    margin-bottom: 0;
    @media (max-width: 769px) {
      font-size: 2.5rem;
    }
`
const StyledH2 = styled(H2)`
  margin: unset;
  font-size: 2.2rem;
`
const StyledP = styled(P)`
  font-size: 1.8rem;
  text-align: left;
  @media (max-width: 769px) {
    font-size: 1.5rem;
  }
`
const FooterP = styled(P)`
  font-size: 1.4rem;
  text-align: left;
  font-style: italic;
`
const StagesContainer = styled.div`
  @media (max-width: 480px) {
    flex-direction: column;
  }
  margin: 3rem 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
const Stage = styled.div`
  width: 100%;
  background-image: linear-gradient(169deg, #f3b706 0%, #f29505 100%);
  color: white;
  border-radius: 10px;
  padding: 1rem 1rem;
  margin: 0 1rem;
  text-align: left;
  height: 20rem;
  @media (max-width: 1140px) {
    min-height: 25rem;
    font-size: 1.5rem;
  }
  @media (max-width: 950px) {
    height: 35rem;
  }
  @media (max-width: 710px) {
    height: 40rem;
  }
  @media (max-width: 480px) {
    height: 15rem;  
  }
`
const Img = styled.img`
  @media (max-width: 480px) {
    transform: rotate(90deg);
  }
  width: 5rem;
`
const LinkContainer = styled.div`
  margin-top: 4rem;
`
const LandingLink = styled.div`
  background-color: #222222;
  font-size: 16px;
  color: #fff;
  letter-spacing: 0;
  cursor: pointer;
  position: relative;
  font-weight: 700;
  text-decoration: none;
  line-height: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  transition: all 0.1s ease-out;
  border-radius: 2.3rem;
  min-height: 4.6rem;
  padding: 1rem 3rem;
  border: none;
`
// endregion

export default Pluses
